import { render, staticRenderFns } from "./OrganogramFlow.vue?vue&type=template&id=15ed0539&scoped=true&"
import script from "./OrganogramFlow.vue?vue&type=script&lang=js&"
export * from "./OrganogramFlow.vue?vue&type=script&lang=js&"
import style0 from "./OrganogramFlow.vue?vue&type=style&index=0&id=15ed0539&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed0539",
  null
  
)

export default component.exports